import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { clsx } from 'clsx';

import { FirstTouchCardComponent } from './first-touch-card.component';
import { FirstTouchModuleConfig } from './first-touch.model';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'first-touch',
  templateUrl: './first-touch.component.html',
  imports: [FirstTouchCardComponent],
  host: {
    '[class]': 'hostClass',
  },
})
export class FirstTouchComponent {
  hostClass = clsx('flex h-full flex-col items-center justify-center overflow-auto bg-surface p-lg');
  config = input.required<FirstTouchModuleConfig>();
  buttonState = input<'default' | 'disabled'>('default');
  buttonClick = output<void>();
}
